
import { Badge } from "@/components/ui/badge";

const SubscriptionInfoCard = () => {
  return (
    <div className="bg-[#F3F7FC] border border-[#C3DAEC] p-6 rounded-lg mb-6">
      <div className="flex items-center mb-4">
        <img
          src="/lovable-uploads/fec2d69a-b8ba-4895-912d-ccfc126e394d.png"
          alt="METRADE PREMIUM"
          className="h-6 mr-3"
        />
        <h3 className="text-xl font-semibold text-[#243949]">Premium Subscription</h3>
      </div>
      <div className="text-[#4A5568] text-sm space-y-2">
        <p>
          By following this strategy, you are subscribing to METRADE Premium which includes:
        </p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Access to all premium strategies</li>
          <li>Continuous strategy monitoring and adjustments</li>
          <li>Advanced analytics and performance tracking</li>
          <li>Priority customer support</li>
        </ul>
      </div>
    </div>
  );
};

export default SubscriptionInfoCard;
